/**
 * @generated SignedSource<<b98434f7ba00350291605fd9c354b1b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PublishState = "ARCHIVED" | "DELETED" | "DRAFT" | "PUBLISHED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ItemOpenedTracker_item$data = {
  readonly __typename: string;
  readonly id: string;
  readonly publishState?: PublishState;
  readonly " $fragmentType": "ItemOpenedTracker_item";
};
export type ItemOpenedTracker_item$key = {
  readonly " $data"?: ItemOpenedTracker_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemOpenedTracker_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publishState",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemOpenedTracker_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "FolderItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "Event",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "5117b957b06016ae006e8bbb04ecf35c";

export default node;
